import { get } from '@bigyouth/base'
import emitter from '../emitter'
import { connectClearRefinements } from 'instantsearch.js/es/connectors'

const renderClearRefinements = (renderOptions, isFirstRender) => {
  const { refine, widgetParams } = renderOptions

  if (isFirstRender) {
    const button = document.createElement('button')
    button.classList.add('filter-clear')
    button.innerHTML = `
      <svg width="21" height="21" class="hidden lg:block mr-2 flex-shrink-0">
        <use href="#icon-reset" xlink:href="#icon-reset"></use>
      </svg>
      <svg width="21" height="21" class="lg:hidden mr-2 flex-shrink-0">
        <use href="#icon-reset2" xlink:href="#icon-reset2"></use>
      </svg>
      <span class="emphasis underline-hover has-bottom-line">${config.trads.reset}</span>`

    button.addEventListener('click', () => {
      refine()
      emitter.trigger('clearCalendar')

      if (get('[js-training-list-panel][data-panel="subthemes"]')) {
        get('[js-training-list-panel][data-panel="subthemes"]').classList.remove('is-visible')
        get('[js-training-list-panel][data-panel="trainings"]').classList.remove('is-visible')
      }
    })

    widgetParams.container.appendChild(button)
  }
}

const customClear = connectClearRefinements(renderClearRefinements)

export default customClear
